import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_root/integrations/messaging/slack')({
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({
      id: 'integrations.categories.messaging.slack',
    }),
  }),
});
